import React, {Fragment, useEffect, useState} from "react";
import {fetchPostCategories} from "../../../redux/actions";
import {Icon, List, Loader} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

export const Categories = ({from, city, path, author}) => {

    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const {id: cityId} = city;

    // console.log('render categories');

    useEffect(() => {

        const fetchData = async () => {

            // start loading
            setIsLoading(true);
            // setPagination({});

            try {

                // get posts
                const result = await fetchPostCategories(cityId, from);

                // set posts
                setCategories(result.data);

            } catch (e) {

                // show errors
                console.log('error', e);
            }

            // stop loading
            setIsLoading(false);
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [cityId]);

    return (
        <Fragment>
            <h3 className="ui header">
                <FormattedMessage id={author.length > 0 ? "Outras Colunas" : "Categorias"}/>
            </h3>

            <List divided relaxed style={{marginTop: 0}}>
                <Loader
                    active={isLoading}
                    inline={true}
                />
                {
                    categories.map((category) => {

                        const {id, slug, name, place_count, author} = category;

                        return (
                            <List.Item
                                as={Link}
                                key={`category-${id}`}
                                to={`${path}/home/${id}/${slug}#author=${author}`}
                            >
                                <List.Content floated='right'>
                                    {place_count}
                                </List.Content>
                                <Icon name='right triangle'/>
                                <List.Content>{name}</List.Content>
                            </List.Item>
                        );
                    })
                }
            </List>
        </Fragment>
    );
};

